// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rw2zdkrxCjqoKH {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: UGGrK2ztDbjmUq;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 120px;
  height: 16px;
  margin-bottom: var(--ds-space-100, 8px);
}
@keyframes UGGrK2ztDbjmUq {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .rw2zdkrxCjqoKH {
    animation: none;
  }
}
.DupgfF14_ywavh {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: UGGrK2ztDbjmUq;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  height: 40px;
  margin-bottom: var(--ds-space-200, 16px);
}
@keyframes UGGrK2ztDbjmUq {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .DupgfF14_ywavh {
    animation: none;
  }
}
.TAejdeI0cug8W1 {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: UGGrK2ztDbjmUq;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  height: 32px;
}
@keyframes UGGrK2ztDbjmUq {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .TAejdeI0cug8W1 {
    animation: none;
  }
}
.ofDvQd8M2VplMI {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-100, 8px);
  margin-top: var(--ds-space-200, 16px);
}
.VbDs1WOx6b2CvM {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 396px;
}
`, ""]);
// Exports
export var skeletonLabelText = `rw2zdkrxCjqoKH`;
export var shimmer = `UGGrK2ztDbjmUq`;
export var skeletonFormInput = `DupgfF14_ywavh`;
export var skeletonButton = `TAejdeI0cug8W1`;
export var buttonGroup = `ofDvQd8M2VplMI`;
export var addCardToPlannerPopover = `VbDs1WOx6b2CvM`;
export default ___CSS_LOADER_EXPORT___;
